/**************************************************
 * Nombre:       Dialogo_Politicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Collapse, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Suscripcion from "../Formularios/Formulario_Suscripcion";
import {validarCorreo} from "../../Utilidades/validarCorreo";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useContext, useState} from "react";
import {theme} from "../../Tema";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {contexApp} from "../../App";
import {useNavigate} from "react-router";
import {useCopiarPortapapeles} from "../../Utilidades/useCopiarPortapapeles";

const Dialogo_Suscripcion = ({cerrar, realizado}) => {
    const cData = useContext(contexApp)
    const navigate = useNavigate()
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const {AvisoPortapapeles, copiarPortapapeles} = useCopiarPortapapeles()
    const {Cargador, Avisos, nuevoAviso, iniciarCarga, terminar} = useCargador({logoRedondo: logo})
    const [open, setOpen] = useState(false)


    let subirDatos = async () => {


        let entidad = await obtenerEntidad()
        entidad.correo = entidad.correo.toLowerCase()

        iniciarCarga('Generando cupón...')
        if (!validarCorreo(entidad.correo)) {
            terminar({aviso: 'Correo invalido, corrigelo e intenta nuevamente', variante: 'error'})
            return
        }

        if (await verificarSiCorreoInscrito(entidad.correo)) {
            terminar({aviso: 'El correo ya se encuentra suscrito, intenta con otro', variante: 'error'})
            return
        }

        entidad.fecha = new Date().getTime()
        let dox = await guardarDoc('suscriptores', entidad)
        if (dox.res) {
            terminar({aviso: 'Exito, usa este correo en tu primera compra'})
            setOpen(true)
        }


    }

    const verificarSiCorreoInscrito = async (correo) => {

        let wheres = [where('correo', '==', correo)]
        let dox = await obtenerColWheres({col: 'suscriptores', wheres: wheres})

        return dox.res && dox.data.length > 0

    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}} sx={{px: 2}}>

            <Cargador/>

            <Avisos/>

            <AvisoPortapapeles/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Suscripcion props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4}}>
                <Collapse in={open} sx={{width: '100%'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                            <Typography sx={{
                                lineHeight: 1.2,
                                color: theme.palette.primary.main,
                                fontSize: 32,
                                fontWeight: 800
                            }}>¡BIENVENIDA! </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                            <Typography sx={{lineHeight: 1.2, textAlign: 'center'}}>
                                Tu registro fue exitoso.
                                <br/>
                                <br/>
                                Has decidido ser parte de una comunidad de mujeres que se atreven a brillar, a sentirse
                                seguras, y a celebrar sus esencia en cada detalle.
                                Disfruta de <span style={{fontWeight: 800}}>10%OFF en tu primera compra</span>
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>

                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'center'}
                                size={{xs: 12, sm: 12, md: 12}} sx={{py: 2}}>


                                <Typography sx={{lineHeight: 1.2, textAlign: 'center'}}>
                                    Cupón:
                                </Typography>


                                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                                    <Typography sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: 24,
                                        fontWeight: 600
                                    }}>AME25</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'} sx={{mt: 1}}>
                                    <Button
                                        onClick={() => copiarPortapapeles('AME25')}
                                        variant={'outlined'} sx={{pb: 0, pt: 0.3}}>
                                        Copiar
                                    </Button>
                                </Grid>

                            </Grid>


                        </Grid>


                    </Grid>


                </Collapse>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4, mb: 4}}>
                {open ?

                    <Button
                        onClick={() => {
                            cerrar();
                            navigate('/DetalleCol/' + cData.actColeccion.id)
                            if (realizado) {
                                realizado()
                            }

                        }
                        }
                    >Comprar Ahora</Button>
                    :
                    <Button
                        onClick={() => subirDatos()}
                    >Suscribirse</Button>

                }

            </Grid>

        </Grid>
    )

}
export default Dialogo_Suscripcion